export enum OfferTypes {
  JoinVIPTable,
  TableBooking,
  GuestList,
}
export enum OfferSettings {
  IsFreeDrinks = "IsFreeDrinks",
  IsFreeEntry = "IsFreeEntry",
  IsFreeDinner = "IsFreeDinner",
  IsFreeTaxi = "IsFreeTaxi",
  IsOther = "IsOther",
  IsGoodyBag = "IsGoodyBag"
}

export enum OfferSettingsView {
  FreeDrinks = "Complimentary Drinks",
  FreeEntry = "Free Entry",
  FreeDinner = "Free Dinner",
  FreeTaxi = "Free Taxi",
  IsOther = "Pre Club Drink",
  IsGoodyBag = "Queue Jump"
}
